// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3kByT","buttons":"PendingPaymentAlert_buttons__2z1HI"};